const API_AUTH_USERNAME = "StaffManagement";
const API_AUTH_PASSWORD = "t746/mFxin8ks74or8hg";
const API_BASE_URL = "https://microdynamicsoftware.uk/StaffManagement/";
const MOBILE_NUMBER = 8888717711;
const EMAIL_ADDRESS = "info@skyflypark.com";
const COMPANY_ADDRESS =
  "103, Vitthal Complex, Near Selfy Point, Narhe, Pune, Maharashtra 411041";
const MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.7205222235743!2d73.82990290000001!3d18.450994299999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2953cbc3bdcf5%3A0x1b88676c6fe0779c!2sMicrodynamic%20Software!5e0!3m2!1sen!2sin!4v1744892734659!5m2!1sen!2sin";
const FACEBOOK_URL = "https://www.facebook.com/MicrodynamicSoftware/";
const INSTGRAM_URL = "https://www.instagram.com/microdynamicsoftware/";
const LINKEDIN_URL = "https://in.linkedin.com/company/microdynamic-software";
const YOU_TUBE_URL = "https://www.youtube.com/channel/UCyHj5LJCasxUhLfrUtlzSZg";
export {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
  MOBILE_NUMBER,
  EMAIL_ADDRESS,
  FACEBOOK_URL,
  INSTGRAM_URL,
  LINKEDIN_URL,
  YOU_TUBE_URL,
  MAP_URL,
  COMPANY_ADDRESS,
};
